import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { toggleDrawer } from '~features/drawer/ducks';
import { markAsSeen, deleteNotification } from './ducks';

import { errorColorLight } from '~theme';

import Timestamp from './components/Timestamp';
import Author from './components/Author';
import Chevron from './components/Chevron';

const StandardNotification = ({
  notification,
  description,
  editing,
  onClick,
  hideInitiator,
}) => {
  const dispatch = useDispatch();

  const handleClick = async () => {
    dispatch(markAsSeen(notification.id));
    dispatch(toggleDrawer('notifications'));
    onClick();
  };

  const handleDelete = async event => {
    event.stopPropagation();
    dispatch(deleteNotification(notification.id));
  };

  return (
    <Wrapper onClick={handleClick}>
      <Description>
        {!notification.seen && <UnseenBadge />}
        <div>{description}</div>
        <Chevron
          editing={editing}
          onClick={editing ? handleDelete : () => null}
        >
          <FontAwesomeIcon icon={editing ? faTimes : faChevronRight} />
        </Chevron>
      </Description>
      <Bottom>
        {notification.initiationTime && (
          <Timestamp date={moment(notification.initiationTime)} />
        )}
        {notification.initiator && !hideInitiator && (
          <Author name={notification.initiator.name} />
        )}
      </Bottom>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 12px 24px;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 8px;
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

const UnseenBadge = styled.div`
  height: 12px;
  width: 12px;
  margin-right: 12px;
  background-color: ${errorColorLight};
  border-radius: 100%;
  flex-shrink: 0;
`;

export default StandardNotification;
